const { COURSE_RUN_AVAILABILITY_ARCHIVED } = require('./discoveryConstants');
// We say that a course is archived if its active course run is archived
const isArchived = (courseRun) => {
  if (courseRun.availability) {
    return courseRun.availability.toLowerCase() === COURSE_RUN_AVAILABILITY_ARCHIVED;
  }

  return false;
};

// HACK: old-school export needed for source-utils/courses.js
module.exports = {
  isArchived,
};
